export default __webpack_public_path__ + "static/media/retireeasy2026-popup-banner.6b169087.jpg";